import React from 'react';
import { render, act } from '@testing-library/react';
import userEvent from '@testing-library/user-event';
import { Snackbar } from './Snackbar';

describe('Snackbar', () => {
	jest.useFakeTimers();
	const user = userEvent.setup();

	it('should call `onClose` when duration ends', () => {
		const onClose = jest.fn();
		render(<Snackbar title="test title" onClose={onClose} />);

		expect(onClose).not.toBeCalled();
		act(() => {
			jest.advanceTimersByTime(5000);
		});
		expect(onClose).toBeCalled();
		expect(onClose).toHaveBeenCalledTimes(1);
	});

	it('should call `onClose` when custom duration ends', () => {
		const onClose = jest.fn();
		const customDuration = 1000;
		render(
			<Snackbar
				title="test title"
				duration={customDuration}
				onClose={onClose}
			/>
		);

		expect(onClose).not.toBeCalled();
		act(() => {
			jest.advanceTimersByTime(customDuration);
		});
		expect(onClose).toBeCalled();
		expect(onClose).toHaveBeenCalledTimes(1);
	});

	it('should call `onClose` when user clicks x', async () => {
		jest.useRealTimers();

		const onClose = jest.fn();
		const { getByRole } = render(
			<Snackbar title="test title" onClose={onClose} />
		);

		expect(onClose).not.toBeCalled();
		await user.click(getByRole('button'));
		expect(onClose).toBeCalled();
		expect(onClose).toHaveBeenCalledTimes(1);
	});

	it('should call `onActionClick` when user clicks Action', async () => {
		jest.useRealTimers();

		const actionName = 'Undo';
		const onActionClick = jest.fn();
		const { getByText } = render(
			<Snackbar
				title="test title"
				actionName={actionName}
				onActionClick={onActionClick}
			/>
		);

		expect(onActionClick).not.toBeCalled();
		await user.click(getByText(actionName));
		expect(onActionClick).toBeCalled();
		expect(onActionClick).toHaveBeenCalledTimes(1);
	});

	it('should pass through data automation attributes', () => {
		const { container, baseElement } = render(
			<Snackbar title="test title" data-auto-sel="automation-selector" />
		);

		/**
		 * NOTE: Using "baseElement" instead of "container" because
		 *       Snackbar is rendered in a portal
		 */
		const nonPortalElement = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);
		const portalElement = baseElement.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(nonPortalElement).toBeNull();
		expect(portalElement).not.toBeNull();
	});
});
